import { render, staticRenderFns } from "./MisMateriasGratis.vue?vue&type=template&id=0badf61f&scoped=true"
import script from "./MisMateriasGratis.vue?vue&type=script&lang=js"
export * from "./MisMateriasGratis.vue?vue&type=script&lang=js"
import style0 from "./MisMateriasGratis.vue?vue&type=style&index=0&id=0badf61f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0badf61f",
  null
  
)

export default component.exports